import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { ChatbotWidget } from './ChatbotWidget';
import ZendeskChatWidget from './ZendeskChatWidget';

function HelpdeskSelector() {
  const enableChatbot = useFeatureFlag('enable-alf-in-patient-portal');

  if (enableChatbot) {
    return <ChatbotWidget />;
  }

  return <ZendeskChatWidget />;
}

export default HelpdeskSelector;
